<template>
  <div>
    <BgImage :image="pageData.introduction.heroImage" />
    <transition>
      <router-view :key="$route.fullPath" class="router-view"></router-view>
    </transition>
    <Sidebar>
      <template v-slot:title>
        <transition>
          <div v-if="!onChildRoute">
            <h1>
              <span class="station-name h1"
                ><span class="text">Roma Street</span></span
              >
              <span class="station h1"><span class="text">Station</span></span>
            </h1>
          </div>
        </transition>
      </template>
      <template v-slot:content>
        <transition>
          <StationExploreHomeIntroduction
            v-if="!onChildRoute"
            :introduction="pageData.introduction"
          />
        </transition>
      </template>
    </Sidebar>
    <ScreenNavigation base="/roma" :routes="localRoutes" />
    <ScreenTitleTab label="Roma Street" />
    <StationHomeLink />
  </div>
</template>

<script>
import StationHomeLink from "@/components/StationHomeLink";
import ScreenTitleTab from "@/components/ScreenTitleTab";
import ScreenNavigation from "@/components/ScreenNavigation";
import Sidebar from "@/components/Sidebar";
import BgImage from "@/components/BgImage";
import StationExploreHomeIntroduction from "@/components/stationExplore/HomeIntroduction";

import mixins from "@/mixins";

const slug = "explore-roma-street";

export default {
  data() {
    return {};
  },
  components: {
    StationHomeLink,
    ScreenTitleTab,
    ScreenNavigation,
    Sidebar,
    BgImage,
    StationExploreHomeIntroduction
  },
  computed: {
    localRoutes: function() {
      return this.childRoutes.filter(function(route) {
        return route.meta.hide === undefined || route.meta.hide !== true;
      });
    },
    pageData() {
      return this.$store.getters.pageData(slug);
    }
  },
  mounted() {
    this.$root.setRootPath("/roma");
  },
  mixins: [mixins]
};
</script>
